const __WEBPACK_NAMESPACE_OBJECT__ = require("@babel/runtime-corejs3/core-js/instance/reduce");